﻿import * as RecaptchaProvider from './recaptcha.provider';
//converted from:https://github.com/VividCortex/angular-recaptcha
export class recaptcha implements ng.IDirective {

    public restrict = 'A';
    public require = '?^^form';
    public scope = {
        response: '=?ngModel',
        key: '=?',
        stoken: '=?',
        theme: '=?',
        size: '=?',
        type: '=?',
        lang: '=?',
        tabindex: '=?',
        required: '=?',
        onCreate: '&',
        onSuccess: '&',
        onExpire: '&'
    };
    
    constructor(
        private $document: ng.IDocumentService,
        private $timeout: ng.ITimeoutService,
        private recaptchaService: RecaptchaProvider.IRecaptchaService) {}
    
    public link(scope: any, elm: ng.IAugmentedJQuery, attrs: any, controller: any) {
        var self = this;
        scope.widgetId = null;

        if (controller && angular.isDefined(attrs.required)) {
            scope.$watch('required', validate);
        }

        var removeCreationListener = scope.$watch('key',(key) => {
                var callback = (gRecaptchaResponse) => {
                    // Safe $apply
                    this.$timeout(() => {
                        scope.response = gRecaptchaResponse;
                        validate();

                        // Notify about the response availability
                        scope.onSuccess({ response: gRecaptchaResponse, widgetId: scope.widgetId });
                    });
                };

                this.recaptchaService.create(elm[0],
                    {
                        callback: callback,
                        sitekey: key,
                        stoken: scope.stoken || attrs.stoken || null,
                        theme: scope.theme || attrs.theme || null,
                        type: scope.type || attrs.type || null,
                        hl: scope.lang || attrs.lang || null,
                        tabindex: scope.tabindex || attrs.tabindex || null,
                        size: scope.size || attrs.size || null,
                        'expired-callback': expired
                    })
                    .then((widgetId) => {
                        // The widget has been created
                        validate();
                        scope.widgetId = widgetId;
                        scope.onCreate({ widgetId: widgetId });

                        scope.$on('$destroy', destroy);

                        scope.$on('reCaptchaReset',
                            (event, resetWidgetId) => {
                                if (angular.isUndefined(resetWidgetId) || widgetId === resetWidgetId) {
                                    scope.response = "";
                                    validate();
                                }
                            });

                    });

                // Remove this listener to avoid creating the widget more than once.
                removeCreationListener();
            });

        function destroy() {
            if (controller) {
                // reset the validity of the form if we were removed
                controller.$setValidity('recaptcha', null);
            }

            cleanup();
        }
        
        function expired() {
            // Safe $apply
            self.$timeout(() => {
                scope.response = "";
                validate();

                // Notify about the response availability
                scope.onExpire({ widgetId: scope.widgetId });
            });
        }

        function validate() {
            if (controller) {
                controller.$setValidity('recaptcha', scope.required === false ? null : Boolean(scope.response));
            }
        }

        function cleanup() {
            self.recaptchaService.destroy(scope.widgetId);
            // removes elements reCaptcha added.
            angular.element(self.$document[0].querySelectorAll('.pls-container')).parent().remove();
        }
    }


    static factory(): ng.IDirectiveFactory {
        const directive: ng.IDirectiveFactory = ($document: ng.IDocumentService, $timeout: ng.ITimeoutService, recaptchaService: RecaptchaProvider.IRecaptchaService) => new recaptcha($document,$timeout,recaptchaService);
        directive.$inject = ['$document', '$timeout','recaptchaService'];
        return directive;
    }
}
